import { render, staticRenderFns } from "./SchoolForm.vue?vue&type=template&id=23de8609&scoped=true&"
import script from "./SchoolForm.vue?vue&type=script&lang=js&"
export * from "./SchoolForm.vue?vue&type=script&lang=js&"
import style0 from "./SchoolForm.vue?vue&type=style&index=0&id=23de8609&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de8609",
  null
  
)

export default component.exports